import { useQuery } from "@tanstack/react-query"
import { conversationAmphoraOriginQuery } from "../lib/conversationAmphoraOriginQuery"

export function useConversationAmphoraOriginQuery(
  ...args: Parameters<typeof conversationAmphoraOriginQuery>
) {
  return useQuery(conversationAmphoraOriginQuery(...args))
}
